"use strict";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdvService = void 0;
const Interfaces_1 = require("../Interfaces");
var IdvService;
(function (IdvService) {
  /**
   * @title YOL Service
   * @version 1.7.0
   * @license MIT
   * @baseUrl /idv
   * @contact YOL Digital <digital-yol@sunrise.net>
   *
   * YOL IDV SERVICE [ 📜 View Changelog](/idv/internal/release-note)
   */
  class Api {
    constructor(url, http) {
      this.selfcare = {
        /**
        * No description
        *
        * @tags Selfcare
        * @name Start
        * @summary Start a new validation id session
        * @request POST:/idv/selfcare/start
        * @secure bearerAuth
        * @response `200` `NewIdSessionResp` Ok
        * @response `400` `{
        error: "ERR_IDV_SCAN_IN_PROGRESS" | "ERR_INVALID_PAYMENT_TYPE",
             }`
        * @response `403` `{
        error: "ERR_UNAUTHORIZED_PLATFORM",
             }`
        * @response `404` `{
        error: "ERR_IDV_SESSION_NOT_FOUND" | "ERR_PAYMENT_TYPE_NOT_FOUND" | "ERR_SELFCARE_ACCOUNT_NOT_FOUND" | "ERR_CUSTOMER_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_FROM_PRODUCT_CATALOG_API" | "ERR_FROM_API" | "ERR_SYSTEM_ERROR" | "ERR_IDV_CREATE_SESSION_FAILED",
             }`
        */
        start: (params = {}) => this.http.request("POST", `${this.url}/idv/selfcare/start`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags Selfcare
        * @name ScanData
        * @summary Get id scan data information for a given id session
        * @request GET:/idv/selfcare/scan-data/{sessionId}
        * @secure bearerAuth
        * @response `200` `ScanDataIdResp` Ok
        * @response `403` `{
        error: "ERR_UNAUTHORIZED_PLATFORM",
             }`
        * @response `404` `{
        error: "ERR_IDV_SESSION_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        scanData: (sessionId, params = {}) => this.http.request("GET", `${this.url}/idv/selfcare/scan-data/${sessionId}`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags Selfcare
        * @name Confirm
        * @summary Confirm a validation id session
        * @request POST:/idv/selfcare/confirm
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_WRONG_EXPIRE_DATE" | "ERR_INVALID_TYPE_ID",
             }`
        * @response `403` `{
        error: "ERR_UNAUTHORIZED_PLATFORM",
             }`
        * @response `404` `{
        error: "ERR_IDV_SESSION_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        confirm: (data, params = {}) => this.http.request("POST", `${this.url}/idv/selfcare/confirm`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        })
      };
      this.http = http;
      this.url = url;
    }
  }
  IdvService.Api = Api;
})(IdvService = exports.IdvService || (exports.IdvService = {}));